import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { calculateFiscalYear, createChart, createChartELCM, formatDate, formatYearRanges } from 'src/app/shared/commen-function-file';
import { ElcmExitPopUpComponent } from '../elcm-exit-pop-up/elcm-exit-pop-up.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { forkJoin } from 'rxjs';
import { ElcmGenericServiceService } from '../_elcm-services/elcm-generic-service.service';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
@Component({
  selector: 'app-elcm-dashboard',
  templateUrl: './elcm-dashboard.component.html',
  styleUrls: ['./elcm-dashboard.component.scss'],
})
export class ElcmDashboardComponent implements OnInit {
  @Input() CheckArrayLength1: any;
  @Input() CheckArrayLength2: any;
  @Input() chechsetupStatus: any;
  @Output() sum = new EventEmitter<any>();
  @Input() yearArray: any;
  @Input() getAllConfiremationusers: any;
  @Input() getProbationEmployeeData: any
  buttonColorName: any;
  loggedInUserRole: any;
  adminAccessData: any = [];
  loggedInUserCompanyID: any;
  subModuleButtonColor: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any
  selectedYear: any;
  pmsYears: any = [];
  loggedInUserId: any;
  fromYear: any;
  toYear: any;
  fromDate: any;
  monthNumber: any;
  fromDate1: any;
  selectedYearForFirstGraph: any;
  fromDate2: any;
  fromDate3: any;
  fromDate4: any;
  selectedYeargraph1: any;
  selectedYeargraph2: any;
  selectedYeargraph3: any;
  selectedYeargraph4: any;
  selectedYeargraph5: any;
  selectedYeargraph6: any;
  fromDate5: any;
  setupNotCompleted: boolean = false;
  confirmationProbationWhomSetup: any
  checkemployeeAcceptedRejected: any;
  listofFromData: any;
  currentlistofFromData: any;
  loggedInUserEmployeeCode: any

  chartStyle!: any;
flag:any
  dropdownSettings: IDropdownSettings = {};
  constructor(public dialog: MatDialog, public sharedService: SharedService, private httpService: HttpService, private PdfDownload: PdfDownloadService, private config: Config, private encryptionService: EncryptionService, private elcmGenericService: ElcmGenericServiceService, public mobileResponsiveService: MobileResponsiveService) { }

  ngOnInit() {
    this.chartStyle = { 'width': this.mobileResponsiveService.graphWidthForMobileDevice, 'height': '400px' }
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserEmployeeCode = sessionStorage.getItem('empCode');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
      if (this.loggedInUserRole == 'Admin') {
        this.elcmGenericService.getAllAccessMatrix(this.loggedInUserCompanyID).subscribe({
          next: (data: any) => this.adminAccessData = (data?.status && data?.data?.access[0]) ? data?.data?.access[0] : []
        });
      }
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.confirmationProbationWhomSetup = this.httpService.confirmationProbationWhomSetup;
    this.setupNotCompleted = this.httpService.notcompletedElcmSetUp;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    // this.getpmsyearlist();
    console.log(this.CheckArrayLength1);
console.log(this.chechsetupStatus+"chechsetupStatus");

    setTimeout(() => {
      this.getpmsyearlist();

      console.log(sessionStorage.getItem('flagData'))

     console.log(this.chechsetupStatus+"chechsetupStatus");


    }, 100)
  }


  getpmsyearlist() {
    // Wait until yearArray actually has data
    if (!this.yearArray || this.yearArray.length === 0) {
      console.warn("yearArray not yet loaded, retrying...");
      setTimeout(() => this.getpmsyearlist(), 100); // retry after 100ms
      return;
    }

    console.log("yearArray received:", this.yearArray);
    this.pmsYears = this.yearArray;

    const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
    const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

    this.setSelectedYear(yearValue);
    this.checkSetUp()
    this.getMonths(this.fromYear, this.toYear);
    this.getterminationFormData();
    this.getExitFormData();
    this.forDepartmentDropDown();

  }
  statusFlag:any;
  checkSetUp() {
    this.httpService
      .callGetService(
        this.config.ckeckSetUpCompleted +
        '/' +
        this.loggedInUserCompanyID +
        '?year=' +
        this.selectedYear
      )
      .subscribe((data: any) => {
        // 👇 if your API directly returns an array
        const setupInfo = Array.isArray(data) ? data[0] : data?.data?.[0];

        if (setupInfo) {
          const exitSetupStatus = setupInfo.forExitNoticePeriodSetup?.[0]?.status ?? false;
          const allSetupStatus = setupInfo.forAllSetup?.[0]?.status ?? false;

        

          // ✅ Final flag
          this.statusFlag = allSetupStatus ;

          // Store in session storage as string ("true"/"false")
          sessionStorage.setItem("statusFlagCheck", JSON.stringify(this.statusFlag));

        } else {
       
      
          
        }
      });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = this.selectedYeargraph1 = this.selectedYeargraph2 =
        this.selectedYeargraph3 = this.selectedYeargraph4 = this.selectedYeargraph5 = this.selectedYeargraph6 = selectedYearObj.year;
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }



  getMonthsByFiscalandReviewCycle: any = [];
  getMonthsList: any = []
  getMonths(fromYear: any, toYear: any) {


    type Month =
      | 'January' | 'February' | 'March' | 'April'
      | 'May' | 'June' | 'July' | 'August'
      | 'September' | 'October' | 'November' | 'December';

    const monthNumbers: Record<Month, number> = {
      January: 1, February: 2, March: 3, April: 4,
      May: 5, June: 6, July: 7, August: 8,
      September: 9, October: 10, November: 11, December: 12,
    };

    // Function to get months based on fiscal year
    const getMonthsByFiscalYear = (fiscalYear: string) => {
      console.log(fiscalYear);

      switch (fiscalYear) {
        case 'Jan_Dec':
          return Object.keys(monthNumbers);
        case 'Apr_Mar':
          return ['April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December', 'January', 'February', 'March'];
        case 'July_Jun':
          return ['July', 'August', 'September', 'October', 'November', 'December', 'January', 'February', 'March', 'April', 'May', 'June'];
        case 'Oct_Sep':
          return ['October', 'November', 'December', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September'];
        default:
          throw new Error(`Unexpected fiscal year: ${fiscalYear}`);
      }
    };

    // Example: Fetching months for a selected fiscal year
    const selectedFiscalYear = this.loggedInCompanyFiscalyear;
    const monthsList = getMonthsByFiscalYear(selectedFiscalYear);

    // Mapping to include month numbers
    const monthsWithNumbers = monthsList.map(month => ({
      name: month,
      number: monthNumbers[month as Month],
    }));
    this.getMonthsList = monthsWithNumbers;
    console.log('Mapped Months:', monthsWithNumbers);
    const today = new Date();
    this.monthNumber = today.getMonth() + 1; // getMonth() returns 0-11, so add 1
    this.fromDate = this.monthNumber
    this.fromDate1 = this.monthNumber
    this.fromDate2 = this.monthNumber
    this.fromDate3 = this.monthNumber
    this.fromDate4 = this.monthNumber
    this.fromDate5 = this.monthNumber

    setTimeout(() => {
      this.manageeveryTabCount();
    }, 800)
    // this.getEmployee()
    // this.getProbationList(); if any bug i need to check this
    // this.hodAndManagerGraph();
    this.getEmployeeList();
    this.commonCountDashBordApi();
    this.switchelcmTypeGraph1('bar');
    this.switchelcmTypeGraph2('bar');
    this.switchElcmTypeGraph3('bar');
    this.switchElcmTypeGraph4('bar');
    this.switchelcmTypeGraphFiledHr('bar');
    this.switchElcmTypeGraphExit('bar');
    // this.forDepartmentDropDown();
    // this.fourthGraph('bar')
    // this.allDropDown();

  }

  employyeApplicationFromdata: any;
  probationCount: any;
  getElCMCountData() {

    if (this.loggedInUserRole == 'Admin') {
      this.employyeApplicationFromdata = {
        "FilledCandidateCount": 0,
        "CandidateCount": 0,
        "OfferLetterCount": 0,
        "HRFilledCount": 0,
        "AppointmentLetterCount": 0,
        "ExtensionCount": 0,
        "ConfirmationCount": 0,
      }

      forkJoin({
        allUserRecords: this.httpService.callGetService(`${this.config.employeeList}/${this.loggedInUserCompanyID}`),
        probationRecords: this.httpService.callGetService(`${this.config.getProbationDetails}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`),
        probationExtend: this.httpService.callGetService(`${this.config.getProbationDetailsWithConfirmationDate}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYear}`),
        confirmedEmployees: this.httpService.callGetService(`${this.config.convertEmployeeList}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`),
      })

      this.elcmGenericService.getAdminDataForDashboard(this.loggedInUserCompanyID, this.selectedYear, this.loggedInCompanyFiscalyear).subscribe({
        next: (response: any) => {
          // console.log('this.loggedInCompanyFiscalyear --------------------------- ', this.selectedYear)
          // console.log('this.adminAccessData?.employeeDetails --------------------------------------- ', this.adminAccessData?.employeeDetails);
          // console.log('allUserRecords --------------------------------------- ', response?.allUserRecords?.data);
          // console.log('probationRecords --------------------------------------- ', response?.probationRecords?.data);
          // console.log('probationExtend --------------------------------------- ', response?.probationExtend?.data);
          // console.log('confirmedEmployees --------------------------------------- ', response?.confirmedEmployees?.data);



          const allResponseFilteredData = this.elcmGenericService.filterDashboardData(this.loggedInUserId, this.selectedYear, response?.allUserRecords, response?.probationRecords, response?.probationExtend, response?.confirmedEmployees, this.adminAccessData);


          /*
          if (response?.allUserRecords?.data) {
            const allUserData = response?.allUserRecords.data.filter( (userData:any) => userData.year == this.selectedYear );
            const allAdminUserRecords = this.elcmGenericService.empFilterForAllEmployeeList(allUserData, Number(this.loggedInUserId), 'hrId', true);
            const usersRecordsLength = allAdminUserRecords.length;

            this.employyeApplicationFromdata.CandidateCount = usersRecordsLength;
            this.employyeApplicationFromdata.HRFilledCount = this.elcmGenericService.getCountOfEmpStatus(allAdminUserRecords, 'FILLED_BY_HR');
            this.employyeApplicationFromdata.OfferLetterCount = this.elcmGenericService.getCountOfEmpStatus(allAdminUserRecords, 'OFFER_LETTER_SENT');
            this.employyeApplicationFromdata.AppointmentLetterCount = this.elcmGenericService.getCountOfEmpStatus(allAdminUserRecords, 'APPROVED_APPOINTMENT_LETTER');
            this.employyeApplicationFromdata.FilledCandidateCount = this.elcmGenericService.getCountOfEmpStatus(allAdminUserRecords, 'FILLED_BY_EMPLOYEE_PENDING_BY_HR');
            }
            
          const probAndConfirm: any = {
            adminProbationRecords: this.elcmGenericService.empFilterForAllEmployeeList(response?.probationRecords?.data, this.adminAccessData?.employeeDetails, 'userId'),
            probationExtend: this.elcmGenericService.empFilterForAllEmployeeList(response?.probationExtend?.data, this.adminAccessData?.employeeDetails, 'userId').filter((probEmp: any) => probEmp.probationStatus === 'Extension'),
            confirmationCount: this.elcmGenericService.empFilterForAllEmployeeList(response?.confirmedEmployees?.data, Number(this.loggedInUserId), 'createdBy', true)
            }
            
            this.probationCount = probAndConfirm?.adminProbationRecords?.length;
            this.employyeApplicationFromdata.ExtensionCount = probAndConfirm?.probationExtend?.length;
            this.employyeApplicationFromdata.ConfirmationCount = probAndConfirm?.confirmationCount?.length;
            
            */
          this.employyeApplicationFromdata.CandidateCount = allResponseFilteredData?.candidateCount;
          this.employyeApplicationFromdata.HRFilledCount = allResponseFilteredData?.hrFilledCount;
          this.employyeApplicationFromdata.OfferLetterCount = allResponseFilteredData?.offerLetterCount;
          this.employyeApplicationFromdata.AppointmentLetterCount = allResponseFilteredData?.appointmentLetterCount;
          this.employyeApplicationFromdata.FilledCandidateCount = allResponseFilteredData?.filledCandidateCount;
          this.employyeApplicationFromdata.ExtensionCount = allResponseFilteredData?.probationExtend?.length;
          this.employyeApplicationFromdata.ConfirmationCount = allResponseFilteredData?.confirmationCount?.length;
          this.probationCount = allResponseFilteredData?.adminProbationRecords?.length;

          this.manageeveryTabCount();
        }
      });
      return;
    }

    // this.httpService.callGetService(`${this.config.elcmgraphCount}?companyId=${this.loggedInUserCompanyID}&month=${this.monthNumber}&year=${this.selectedYear}`).subscribe((response: any) => {
    //   this.employyeApplicationFromdata = response.data;
    //   console.log(this.employyeApplicationFromdata);
    //   this.manageeveryTabCount();
    // });
    if (this.commanCountArray) {
      this.employyeApplicationFromdata = this.commanCountArray?.candidateCount[0];
      console.log(this.employyeApplicationFromdata);
      this.manageeveryTabCount();
    }
    this.httpService.callGetService(`${this.config.probationCount}?companyId=${this.loggedInUserCompanyID}&month=${this.monthNumber}&yearRange=${this.selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`).subscribe((response: any) => {
      this.probationCount = response.data;
      console.log(this.probationCount);
      this.manageeveryTabCount();
    });
  }

  onClickYtdYear(event: any, valueName: any, graphNo: any) {
    console.log('event, valueName, graphNo ---------------------- ', event, valueName, graphNo);

    if (valueName == 'Year') {
      if (graphNo == 'graph1') {
        this.selectedYeargraph1 = event.value;
        console.log(this.selectedYear);

        this.firstGraph(this.isElcmTypeIcon);
      }
      if (graphNo == 'graph2') {
        // this.selectedYear = event.value;
        this.selectedYeargraph2 = event.value;
        console.log(this.selectedYear);

        this.hrField2Graph(this.isElcmTypeIconFieldHr);
      }
      if (graphNo == 'graph3') {
        // this.selectedYear = event.value;
        console.log(this.selectedYear);
        this.selectedYeargraph3 = event.value;
        this.secondGraph(this.isElcmTypeIcon2);
      }
      if (graphNo == 'graph4') {
        // this.selectedYear = event.value;
        console.log(this.selectedYear);
        this.selectedYeargraph4 = event.value;
        this.thirdGraph(this.isElcmTypeIcon3);
      }
      if (graphNo == 'graph5') {
        // this.selectedYear = event.value;
        console.log(this.selectedYear);
        this.selectedYeargraph5 = event.value;
        this.getEmployeeList();
        this.fourthGraph(this.isElcmTypeIcon4);
      }
      if (graphNo == 'graph6') {
        // this.selectedYear = event.value;

        this.selectedYeargraph6 = event.value;

        this.exitGraph(this.isElcmTypeIconExit);
      }
      if (graphNo == 'all') {
        // this.selectedYear = event.value;

        console.log(this.selectedYear);
        this.selectedYear = event.value;
        this.selectedYeargraph1 = event.value;
        this.selectedYeargraph2 = event.value;
        this.selectedYeargraph3 = event.value;
        this.selectedYeargraph4 = event.value;
        this.selectedYeargraph5 = event.value;
        this.selectedYeargraph6 = event.value;
        // this.getElCMCountData();
        this.getEmployeeList();
        this.firstGraph(this.isElcmTypeIcon);
        this.hrField2Graph(this.isElcmTypeIconFieldHr);
        this.secondGraph(this.isElcmTypeIcon2);
        this.thirdGraph(this.isElcmTypeIcon3);

        // this.fourthGraph(this.isElcmTypeIcon4);
        this.exitGraph(this.isElcmTypeIconExit);
        this.getExitFormData();
        this.getterminationFormData();
        this.commonCountDashBordApi();


        const today = new Date();
        this.fromDate = today.getMonth() + 1;


      }

    } else {
      if (graphNo == 'graph1') {

        this.fromDate1 = event.value;
        // this.monthNumber=this.fromDate;
        console.log(this.monthNumber);

        this.firstGraph(this.isElcmTypeIcon);
      }
      if (graphNo == 'graph2') {
        // this.selectedYear = event.value;
        this.fromDate2 = event.value;

        this.hrField2Graph(this.isElcmTypeIconFieldHr);
      }
      if (graphNo == 'graph3') {
        // this.selectedYear = event.value;
        this.fromDate3 = event.value;

        this.secondGraph(this.isElcmTypeIcon2);
      }
      if (graphNo == 'graph4') {
        // this.selectedYear = event.value;
        this.fromDate4 = event.value;

        this.thirdGraph(this.isElcmTypeIcon3);
      }
      if (graphNo == 'graph5') {
        // this.selectedYear = event.value;
        this.fromDate5 = event.value;

        this.fourthGraph(this.isElcmTypeIcon4);
      }
      if (graphNo == 'graph6') {
        // this.selectedYear = event.value;
        this.terminationMonth = event.value;

        this.exitGraph(this.isElcmTypeIconExit);
      }
      if (graphNo == 'all') {
        // this.selectedYear = event.value;
        this.fromDate1 = event.value;
        this.fromDate2 = event.value;
        this.fromDate3 = event.value;
        this.fromDate4 = event.value;
        this.fromDate5 = event.value;
        this.fromDate = event.value;
        this.terminationMonth = event.value;
        this.monthNumber = event.value;
        this.firstGraph(this.isElcmTypeIcon);
        this.hrField2Graph(this.isElcmTypeIconFieldHr);
        this.secondGraph(this.isElcmTypeIcon2);
        this.thirdGraph(this.isElcmTypeIcon3);
        this.fourthGraph(this.isElcmTypeIcon4);
        this.exitGraph(this.isElcmTypeIconExit)
        // this.getElCMCountData();
        this.filterByFiscalMonthRange(this.fromDate)
        this.commonCountDashBordApi();
      }

    }

  }

  counterModule = [
    {
      moduleActiveIcon: '././assets/icon/activeEmp.svg',
      ModuleName: 'Emp. appl. filled by candidate vs sent by HR',
      totalCount: 0,
      color: '#3067FA',
      background: '#D4DBEB',
      routerName: '/home/configrations/plants'
    },
    {
      moduleActiveIcon: '././assets/icon/goalSetting.svg',
      ModuleName: 'Emp. appl. filled by HR vs filled by candidate',
      totalCount: 0,
      color: '#F3820E',
      background: '#FFE3C3',
      routerName: '/home/configrations/departments'
    },
    {
      moduleActiveIcon: '././assets/icon/goalReview.svg',
      ModuleName: 'Offer letter sent by HR vs. emp. appl. filled by HR',
      totalCount: 0,
      color: '#33B060',
      background: '#D5EBDD',
      routerName: '/home/configrations/shifts'
    },
    {
      moduleActiveIcon: '././assets/icon/goalReview.svg',
      ModuleName: 'Cand. joined and appointment letter issued vs offer letter sent by HR',
      totalCount: 0,
      color: '#33B060',
      background: '#D5EBDD',
      routerName: '/home/configrations/shifts'
    },

    {
      moduleActiveIcon: '././assets/icon/exitedEmp.svg',
      ModuleName: 'On probation',
      totalCount: 0,
      color: '#E94848',
      background: '#F2DEDE',
      routerName: '/home/configrations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/settingStatus.svg',
      ModuleName: 'Probation Extended',
      totalCount: 0,
      color: '#393186',
      background: '#DCDBEB',
      routerName: '/home/configrations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/reviewStatus.svg',
      ModuleName: 'Confirmed',
      totalCount: 0,
      color: '#5C4CD3',
      background: '#D9D7EB',
      routerName: '/home/configrations/incident-types'
    },

    {
      moduleActiveIcon: '././assets/icon/activeEmp.svg',
      ModuleName: 'Resigned Emp',
      totalCount: 0,
      color: '#982F2F',
      background: '#EECBCB',
      routerName: '/home/configurations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/exitedEmp.svg',
      ModuleName: 'Regrettable Emp',
      totalCount: 0,
      color: '#982F2F',
      background: '#EECBCB',
      routerName: '/home/configurations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/activeEmp.svg',
      ModuleName: 'Resignation Accepted Emp',
      totalCount: 0,
      color: '#982F2F',
      background: '#EECBCB',
      routerName: '/home/configurations/incident-types'
    },

    {
      moduleActiveIcon: '././assets/icon/exitedEmp.svg',
      ModuleName: 'Terminated Emp',
      totalCount: 0,
      color: '#982F2F',
      background: '#EECBCB',
      routerName: '/home/configurations/incident-types'
    }

  ]

  counterModuleForHODAndManager1 = [

    {
      moduleActiveIcon: '././assets/icon/exitedEmp.svg',
      ModuleName: 'On probation',
      totalCount: 0,
      color: '#E94848',
      background: '#F2DEDE',
      routerName: '/home/configrations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/settingStatus.svg',
      ModuleName: 'Probation Extended',
      totalCount: 0,
      color: '#393186',
      background: '#DCDBEB',
      routerName: '/home/configrations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/reviewStatus.svg',
      ModuleName: 'Confirmed',
      totalCount: 0,
      color: '#5C4CD3',
      background: '#D9D7EB',
      routerName: '/home/configrations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/activeEmp.svg',
      ModuleName: 'Resigned Emp',
      totalCount: 0,
      color: '#982F2F',
      background: '#EECBCB',
      routerName: '/home/configurations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/exitedEmp.svg',
      ModuleName: 'Regrettable Emp',
      totalCount: 0,
      color: '#982F2F',
      background: '#EECBCB',
      routerName: '/home/configurations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/activeEmp.svg',
      ModuleName: 'Resignation Accepted Emp',
      totalCount: 0,
      color: '#982F2F',
      background: '#EECBCB',
      routerName: '/home/configurations/incident-types'
    },


  ]

  forExit = [
    {
      moduleActiveIcon: '././assets/icon/activeEmp.svg',
      ModuleName: 'Resigned Emp',
      totalCount: 0,
      color: '#982F2F',
      background: '#EECBCB',
      routerName: '/home/configurations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/exitedEmp.svg',
      ModuleName: 'Regrettable Emp',
      totalCount: 0,
      color: '#982F2F',
      background: '#EECBCB',
      routerName: '/home/configurations/incident-types'
    },

    {
      moduleActiveIcon: '././assets/icon/activeEmp.svg',
      ModuleName: 'Resignation Accepted Emp',
      totalCount: 0,
      color: '#982F2F',
      background: '#EECBCB',
      routerName: '/home/configurations/incident-types'
    },


  ]



  isElcmTypeIcon: any = 'bar';
  isElcmTypetable: boolean = false;
  switchelcmTypeGraph1(type: any) {
    this.isElcmTypeIcon = type;
    this.isElcmTypetable = false;

    setTimeout(() => {
      this.firstGraph(this.isElcmTypeIcon);
    }, 800);
  }


  switchElcmTypeTable1() {
    this.isElcmTypeIcon = 'table';
    this.isElcmTypetable = true;
  }
  selectedFromDated: any;
  selectedtoDated: any;
  downloadChartAsPDF(type: any): void {
    const currentDate = new Date();
    const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

    const formattedFromDate = this.selectedFromDated ? formatDate(this.selectedFromDated) : '';
    const formattedtoDate = this.selectedtoDated ? formatDate(this.selectedtoDated) : '';

    let idSelector = '';
    let date: any
    let selectedYearForElcm: any = this.selectedYear;
    let selectDepartMent: any
    switch (type) {
      case 'Emp. appl. filled by candidate vs sent by HR':
        idSelector = this.isElcmTypeIcon === 'table' ? 'graph1-table-data' : 'chart-bar-application';
        selectedYearForElcm = this.selectedYeargraph1
        date = this.fromDate1;

        break;
      case 'Emp. appl. filled by HR vs filled by candidate':
        idSelector = this.isElcmTypeIconFieldHr === 'table' ? 'graph2-table-data' : 'filed-hr-chart';
        selectedYearForElcm = this.selectedYeargraph2
        date = this.fromDate2;
        break;
      case 'Offer letter sent by HR vs. emp. appl. filled by HR':
        idSelector = this.isElcmTypeIconFieldHr === 'table' ? 'graph3-table-data' : 'offer-letter-chart';
        selectedYearForElcm = this.selectedYeargraph3
        date = this.fromDate3;
        selectDepartMent = this.selectDepartment
        break;
      case 'Cand. joined and appointment letter issued vs offer letter sent by HR':
        idSelector = this.isElcmTypeIconFieldHr === 'table' ? 'graph4-table-data' : 'third-elcm-chart';
        selectedYearForElcm = this.selectedYeargraph4
        date = this.fromDate4
        selectDepartMent = this.selectDepartmentForofferAndAppoinment
        break;
      case 'Probation vs extension vs confirmation':
        idSelector = this.isElcmTypeIconFieldHr === 'table' ? 'graph5-table-data' : 'fourth-elcm-chart';
        selectedYearForElcm = ""
        date = ""
        selectDepartMent = this.selectDepartmentForFourthGraph
        break;
      case 'Total Exited Vs Resigned Vs Terminated':
        idSelector = this.isElcmTypeIconFieldHr === 'table' ? 'exit-table-data' : 'exit-elcm-chart';
        selectedYearForElcm = this.selectedYeargraph6
        date = this.terminationMonth
        selectDepartMent = this.selectedDepartment
        break;
      default:
        // idSelector = this.selectGraphType === 'table' ? 'table-data-asset-allocatin-count' : 'bar-line-asset-allocatiom-chart';
        break;
    }

    let selectedYearForELCM;
    if (this.loggedInCompanyFiscalyear === "Jan_Dec") {
      selectedYearForELCM = selectedYearForElcm.split("-")[0];
    } else if (idSelector !== 'Probation vs extension vs confirmation') {
      // let startYear: number = parseInt(selectedYearForElcm.split("-")[0].replace("FY ", "").trim());
      // // Calculate end year
      // let endYear: number = startYear + 1;
      // // Build back the FY format
      // selectedYearForELCM = `FY ${startYear}-${endYear.toString().slice(-2)}`;

      if (selectedYearForElcm && selectedYearForElcm.includes("-")) {
        let startYear = parseInt(selectedYearForElcm.split("-")[0].replace("FY", "").trim());

        if (!isNaN(startYear)) {
          let endYear = startYear + 1;
          selectedYearForELCM = `FY ${startYear}-${endYear.toString().slice(-2)}`;
        } else {
          selectedYearForELCM = ""; // fallback if parsing failed
        }
      }
    }
    if (idSelector === 'Probation vs extension vs confirmation') {
      selectedYearForELCM = ""; // Don't show the year
    }
    // Call the common function from the service
    const months = [
      { num: 1, name: 'Jan' },
      { num: 2, name: 'Feb' },
      { num: 3, name: 'Mar' },
      { num: 4, name: 'Apr' },
      { num: 5, name: 'May' },
      { num: 6, name: 'Jun' },
      { num: 7, name: 'Jul' },
      { num: 8, name: 'Aug' },
      { num: 9, name: 'Sep' },
      { num: 10, name: 'Oct' },
      { num: 11, name: 'Nov' },
      { num: 12, name: 'Dec' }
    ];
    let filtermonth = months?.filter((elm: any) => elm.num == date);
    console.log(filtermonth);

    this.PdfDownload.downloadPDFMonthwiseAndDepart(

      idSelector, // chartId
      type, // Title
      selectedYearForELCM, // Year
      filtermonth[0]?.name,
      selectDepartMent, // From Date

    );
  }


  isElcmTypeIconFieldHr: string = 'bar';
  isElcmTypetableFieldHr: boolean = false;
  switchelcmTypeGraphFiledHr(type: any): void {
    this.isElcmTypeIconFieldHr = type;
    this.isElcmTypetableFieldHr = false;
    this.hrField2Graph(this.isElcmTypeIconFieldHr)
  }

  switchElcmTypeTableFieldHr(): void {
    this.isElcmTypetableFieldHr = !this.isElcmTypetableFieldHr;
    this.isElcmTypeIconFieldHr = 'table';
  }
  selectdepartMentForHrField(event: any) {

  }


  isElcmTypeIcon2: any = 'bar'; // Second Graph Type
  isElcmTypetable2: boolean = false; // Second Table View
  switchelcmTypeGraph2(type: any) {
    this.isElcmTypeIcon2 = type;
    this.isElcmTypetable2 = false;

    setTimeout(() => {
      this.secondGraph(this.isElcmTypeIcon2);

    }, 800);
  }

  // Function to switch between table and chart for the second graph
  switchElcmTypeTable2() {
    this.isElcmTypeIcon2 = 'table';
    this.isElcmTypetable2 = !this.isElcmTypetable2;

  }


  isElcmTypeIcon3: string = 'bar';
  isElcmTypetable3: boolean = false;
  selectDepartmentForofferAndAppoinment: any
  switchElcmTypeGraph3(type: string) {
    this.isElcmTypeIcon3 = type;
    this.isElcmTypetable3 = false;
    setTimeout(() => {
      this.thirdGraph(this.isElcmTypeIcon3);

    }, 200);
  }

  switchElcmTypeTable3() {
    this.isElcmTypeIcon3 = 'table';
    this.isElcmTypetable3 = !this.isElcmTypetable3;

  }

  selectDepartment3(event: any) {
    console.log('Selected Department:', event.value);
    this.selectDepartmentForofferAndAppoinment = event.value;
    this.thirdGraph(this.isElcmTypeIcon3)
  }

  isElcmTypeIcon4: string = 'bar'; // Default graph type
  isElcmTypetable4: boolean = false; // Toggle between table and chart
  departmentDataForFourthGraph: any[] = []; // Data for the graph/table
  switchElcmTypeGraph4(type: string) {
    this.isElcmTypeIcon4 = type;
    this.isElcmTypetable4 = false; // Hide table when switching graphs
    this.fourthGraph(this.isElcmTypeIcon4);
  }

  // Function to toggle table view
  switchElcmTypeTable4() {
    this.isElcmTypeIcon4 = 'table';
    this.isElcmTypetable4 = !this.isElcmTypetable4;
  }
  isElcmTypeIconExit: any = 'bar';
  isElcmTypetableExit: boolean = false
  switchElcmTypeTableExit() {
    this.isElcmTypeIconExit = 'table';
    this.isElcmTypetableExit = !this.isElcmTypetableExit;
  }
  switchElcmTypeGraphExit(type: string) {
    this.isElcmTypeIconExit = type
    this.isElcmTypetableExit = false; // Hide table when switching graphs
    this.exitGraph(this.isElcmTypeIconExit);
  }
  // Function to select department data
  selectDepartmentForFourthGraph: any
  selectDepartment4(event: any) {
    this.selectDepartmentForFourthGraph = event.value;
    console.log(this.selectDepartmentForFourthGraph);

    this.fourthGraph(this.isElcmTypeIcon4);
  }
  commanCountArray: any = []
  commonCountDashBordApi() {

    this.httpService.callGetService(`${this.config.commanDashboardCountApi}?companyId=${this.loggedInUserCompanyID}&month=${this.monthNumber}&year=${this.selectedYear}`)
      .subscribe((response: any) => {
        this.commanCountArray = response?.data;

        this.getElCMCountData();
      })
  }
  firstGraphTableData: any;
  firstGraph(graphtype: any) {
    console.log("Checking for chart container...");

    if (this.loggedInUserRole == 'Admin') {
      this.elcmGenericService.getAdminDataForDashboard(this.loggedInUserCompanyID, this.selectedYeargraph1, this.loggedInCompanyFiscalyear).subscribe({
        next: (response: any) => {
          const allResponseFilteredData = this.elcmGenericService.filterDashboardData(this.loggedInUserId, this.selectedYeargraph1, response?.allUserRecords, response?.probationRecords, response?.probationExtend, response?.confirmedEmployees, this.adminAccessData);

          console.log('allResponseFilteredData ------------------------- ', allResponseFilteredData);

          this.setFirstGraphData({
            data: { CandidateCount: allResponseFilteredData?.candidateCount, FilledCandidateCount: allResponseFilteredData?.filledCandidateCount },
            message: "fetched successfully",
            status: true
          }, graphtype);
        }
      });
      return;
    }

    this.httpService.callGetService(`${this.config.elcmFirstGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate1}&year=${this.selectedYeargraph1}`)
      .subscribe((response: any) => {
        this.setFirstGraphData(response, graphtype);
        /*
        console.log('Checking for chart container -------------------- ', response);
        let data = response.data;
        this.firstGraphTableData = data;
        setTimeout(() => {

          const chartElement = document.getElementById('chart-bar-application');
          if (!chartElement) {
            console.error("Chart container with id 'chart-bar-quarterly' not found.");
            return;
          }

          console.log('data.CandidateCount ------------------------- ', data.CandidateCount)
          let candidateData = [
            { platform: 'Sent by HR', data1: data.CandidateCount },
            { platform: 'Emp. appl. filled ', data2: data.FilledCandidateCount }
          ];

          createChartELCM('chart-bar-application', graphtype, candidateData);
        }, 200);  // Delay to allow the DOM to load
        */
      });
  }
  setFirstGraphData(apiData: any, graphtype: any) {
    let data = apiData.data;
    this.firstGraphTableData = data;
    setTimeout(() => {
      const chartElement = document.getElementById('chart-bar-application');
      if (!chartElement) return;

      let candidateData = [
        { platform: 'Sent by HR', data1: data.CandidateCount },
        { platform: 'Emp. appl. filled ', data2: data.FilledCandidateCount }
      ];
      createChartELCM('chart-bar-application', graphtype, candidateData);
      this.mobileResponsiveService.chartResizeFn(chartElement);
    }, 800);  // Delay to allow the DOM to load
  }

  selectDepartment: any;
  selectdepartMent(event: any) {
    console.log(event.value);
    this.selectDepartment = event.value;
    this.secondGraph(this.isElcmTypeIcon2);
  }

  hrFieldcandidateData: any = []
  hrField2Graph(graphtype: any) {

    if (this.loggedInUserRole == 'Admin') {
      this.elcmGenericService.getAdminDataForDashboard(this.loggedInUserCompanyID, this.selectedYeargraph2, this.loggedInCompanyFiscalyear).subscribe({
        next: (response: any) => {
          const allResponseFilteredData = this.elcmGenericService.filterDashboardData(this.loggedInUserId, this.selectedYeargraph2, response?.allUserRecords, response?.probationRecords, response?.probationExtend, response?.confirmedEmployees, this.adminAccessData);
          this.sethrField2GraphData({
            data: { FilledHRCount: allResponseFilteredData?.filledCandidateCount, FilledCandidateCount: allResponseFilteredData?.candidateCount },
            message: "fetched successfully",
            status: true
          }, graphtype);
        }
      });
      return;
    }


    let url;
    if (this.selectDepartment) {
      url = `${this.config.elcmHrFieldSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate2}&year=${this.selectedYeargraph2}&department=${this.selectDepartment}`
    } else {
      url = `${this.config.elcmHrFieldSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate2}&year=${this.selectedYeargraph2}`
    }

    // this.httpService.callGetService(`${this.config.elcmSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=2&year=${this.selectedYear}&department=null`)
    this.httpService.callGetService(url)
      .subscribe((response: any) => {
        this.sethrField2GraphData(response, graphtype);
        /*
        this.hrFieldcandidateData = response.data;
        setTimeout(() => {

          const chartElement = document.getElementById('filed-hr-chart');
          if (!chartElement) {
            console.error("Chart container with id 'chart-bar-quarterly' not found.");
            return;
          }

          let candidateData = [
            { platform: 'Emp. appl.filled by HR', data1: response.data.FilledHRCount },
            { platform: 'Filled by candidate', data2: response.data.FilledCandidateCount }
          ];

          createChartELCM('filed-hr-chart', graphtype, candidateData);
        }, 200);  // Delay to allow the DOM to load
        */
      })
  }

  sethrField2GraphData(response: any, graphtype: any) {
    console.log('sethrField2GraphData ------------------- ', response)
    this.hrFieldcandidateData = response.data;
    setTimeout(() => {
      const chartElement = document.getElementById('filed-hr-chart');
      if (!chartElement) return;

      let candidateData = [
        { platform: 'Emp. appl.filled by HR', data1: response.data.FilledHRCount },
        { platform: 'Filled by candidate', data2: response.data.FilledCandidateCount }
      ];
      createChartELCM('filed-hr-chart', graphtype, candidateData);
      this.mobileResponsiveService.chartResizeFn(chartElement);
    }, 800);  // Delay to allow the DOM to load
  }


  departmentData: any = []
  secondGraph(graphtype: any) {
    let url;

    if (this.selectDepartment) {
      url = `${this.config.elcmSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate3}&year=${this.selectedYeargraph3}&department=${this.selectDepartment}`
    } else {
      url = `${this.config.elcmSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate3}&year=${this.selectedYeargraph3}`

    }

    // this.httpService.callGetService(`${this.config.elcmSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=2&year=${this.selectedYear}&department=null`)
    this.httpService.callGetService(url)
      .subscribe((response: any) => {
        // Step 1: Convert object to array
        const transformedData = response.data.map((item: any) => ({
          xAxisValueData: item["Department Name"],
          seriesValueOneData: item["Send-Offer-Letter"],
          seriesValueTwoData: item["HR-Filled-Count"],
        }));

        this.departmentData = transformedData;
        transformedData.xAxisName = 'Department';
        transformedData.yAxisName = 'Department Count';
        transformedData.seriesLabelOne = 'Offer letter sent by HR';
        transformedData.seriesLabelTwo = 'Emp. appl. filled by HR';

        if (graphtype == 'bar') {
          this.elcmBarChartActive(transformedData, 'offer-letter-chart', 'double');
        }
        if (graphtype == 'line') {
          this.elcmLineChartActive(transformedData, 'offer-letter-chart', 'double');
        }



      })
  }
  departmentDataForThirdGraphDD: any = [];
  departmentDataSecondDD: any = [];
  allDropDown() {

    let url2 = `${this.config.elcmSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate3}&year=${this.selectedYeargraph3}`
    let url3 = `${this.config.elcmThirdGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate4}&year=${this.selectedYeargraph4}`

    this.httpService.callGetService(url2)
      .subscribe((response: any) => {
        // Step 1: Convert object to array
        const transformedData = response.data.map((item: any) => ({
          xAxisValueData: item["Department Name"],

        }));

        this.departmentDataSecondDD = transformedData;
      })

    this.httpService.callGetService(url3)
      .subscribe((response: any) => {
        // Step 1: Convert object to array
        console.log(response);

        const transformedData = response.data.map((item: any) => ({
          xAxisValueData: item["Department Name"],
        }))

        this.departmentDataForThirdGraphDD = transformedData;
      })
  }
  tableData: any;
  departmentDataForThirdGraph: any
  thirdGraph(graphtype: any) {
    let url;

    if (this.selectDepartmentForofferAndAppoinment) {
      url = `${this.config.elcmThirdGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate4}&year=${this.selectedYeargraph4}&department=${this.selectDepartmentForofferAndAppoinment}`
    } else {
      url = `${this.config.elcmThirdGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate4}&year=${this.selectedYeargraph4}`

    }

    // this.httpService.callGetService(`${this.config.elcmSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=2&year=${this.selectedYear}&department=null`)
    this.httpService.callGetService(url)
      .subscribe((response: any) => {
        // Step 1: Convert object to array
        const transformedData = response.data.map((item: any) => ({
          xAxisValueData: item["Department Name"],
          seriesValueOneData: item["Send-Offer-Letter"],
          seriesValueTwoData: item["Approved-Appointment-Letter"],
        }));
        this.tableData = transformedData;
        const normalize = (str: string): string =>
          str
            ?.replace(/\s*-\s*/g, ' - ') // normalize spaces around hyphen
            .replace(/\s+/g, ' ')        // collapse multiple spaces
            .replace(/\u200B/g, '')      // remove hidden zero-width spaces
            .trim()
            .toLowerCase();
        const seen = new Set<string>();
        this.departmentDataForThirdGraphDD = transformedData.filter((item: any) => {
          const key = normalize(item.xAxisValueData);
          return key && !seen.has(key) && seen.add(key);
        });
        this.departmentDataForThirdGraph = transformedData;
        transformedData.xAxisName = 'Department';
        transformedData.yAxisName = 'Department Count';
        transformedData.seriesLabelOne = 'Offer letter sent by HR';
        transformedData.seriesLabelTwo = 'Cand. joined and appointment letter issued';

        if (graphtype == 'bar') {
          this.elcmBarChartActive(transformedData, 'third-elcm-chart', 'double');
        }
        if (graphtype == 'line') {
          this.elcmLineChartActive(transformedData, 'third-elcm-chart', 'double');
        }



      })
  }
  probationListData: any = [];
  //   }
  employeesDetails: any = []
  employeesProbationDetails: any = []
  currentemployeesDetails: any = []
  getEmployeeList() {

    // this.selectedYear
    // this.httpService.callGetService(`${this.config.getProbationDetails}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYeargraph5}&fiscalType=${this.loggedInCompanyFiscalyear}`).subscribe((record: any) => {
    //   this.currentemployeesDetails = [];
    //   this.employeesDetails = [];
    //   if (record.data !== null) {
    //     this.currentemployeesDetails = [];
    //     this.employeesDetails = [];
    //     console.log("jfffffffffffffffffffffffffffff", record.data);

    //     this.employeesDetails = record.data.map((record: any) => {
    //       return {
    //         ...record,
    //         probationStatus: null,
    //         probationExtensionByDay: null,
    //         reasonForExtension: null,
    //         changesPostConfirmation: null,
    //         dateOfConfirmation: null
    //       }
    //     });

    //     if (this.loggedInUserRole == 'Admin') this.employeesDetails = this.elcmGenericService.empFilterForAllEmployeeList(record?.data, this.adminAccessData?.employeeDetails, 'userId');

    //     this.currentemployeesDetails = this.employeesDetails;
    //     console.log(this.currentemployeesDetails + "1102------");

    //   }
    //   console.log("outside if" + this.employeesDetails);

    //   this.fourthGraph(this.isElcmTypeIcon4)
    // })
    setTimeout(() => {

      this.currentemployeesDetails = [];
      this.employeesDetails = [];
      if (this.getProbationEmployeeData) {

        console.log("jfffffffffffffffffffffffffffff", this.getProbationEmployeeData);

        this.employeesDetails = this.getProbationEmployeeData.map((record: any) => {
          return {
            ...record,
            probationStatus: null,
            probationExtensionByDay: null,
            reasonForExtension: null,
            changesPostConfirmation: null,
            dateOfConfirmation: null
          }
        });

        if (this.loggedInUserRole == 'Admin') this.employeesDetails = this.elcmGenericService.empFilterForAllEmployeeList(this.getProbationEmployeeData, this.adminAccessData?.employeeDetails, 'userId');

        this.currentemployeesDetails = this.employeesDetails;
        console.log(this.currentemployeesDetails + "1102------");



      }
      console.log("outside if" + this.employeesDetails);

      this.fourthGraph(this.isElcmTypeIcon4)
    }, 200)
  }


  departmentDataForFourthGraphDD: any = []



  commanDataForProbation: any;
  forDepartmentDropDown() {
    if (
      ['HR Admin', 'Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(this.loggedInUserRole)
    ) {
      const url = `${this.config.elcmFourthGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate5}&year=${this.selectedYeargraph5}`;
      const probationUrl = `${this.config.getProbationDetailsDepartMent}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYear}`;
      let ddEmployeeDetails: any[] = []
      forkJoin([
        this.httpService.callGetService(probationUrl),
        // this.httpService.callGetService(url)
      ]).subscribe(([probationRes]: any) => {
        ddEmployeeDetails = probationRes.data
        this.commanDataForProbation = ddEmployeeDetails
      });
    }
  }
  fourthGraphDropDownData: any;

  fourthGraph(graphtype: any) {

    if ((this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD')) {

      let url;

      if (this.selectDepartmentForFourthGraph) {
        url = `${this.config.elcmFourthGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate5}&year=${this.selectedYeargraph5}&department=${this.selectDepartmentForFourthGraph}`
      } else {
        url = `${this.config.elcmFourthGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate5}&year=${this.selectedYeargraph5}`

      }

      this.httpService.callGetService(url)
        .subscribe((response: any) => {
          this.employeesDetails = [];
          this.fourthGraphDropDownData = response?.data;
          if (this.fourthGraphDropDownData) {

          }
          // if (this.selectDepartmentForFourthGraph) {
          //   console.log(this.currentemployeesDetails);
          //   this.employeesDetails = this.currentemployeesDetails.filter((elm: any) => {
          //     const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
          //     return elm.empDept === this.selectDepartmentForFourthGraph && joiningMonth === this.fromDate5;
          // });

          //   console.log(response.data);


          // } else {

          //   this.employeesDetails = this.currentemployeesDetails.filter((elm: any) => {
          //     const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
          //     return joiningMonth === this.fromDate5;
          // });


          // }


          if (this.selectDepartmentForFourthGraph) {

            this.employeesDetails = this.currentemployeesDetails?.filter((elm: any) => {
              const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
              return elm.empDept === this.selectDepartmentForFourthGraph;
            });

            console.log(response.data);


          } else {
            console.log("hhhhhhhhhhhhhhjjjjjjjjjjjj");
            console.log(this.fourthGraphDropDownData);

            this.employeesDetails = this.currentemployeesDetails;
          }
          console.log(response);

          let commanData = [...this.employeesDetails, ...response.data];
          console.log("commanData", commanData);

          const transformedData: TransformedData = Object.values(
            commanData.reduce((acc: any, item: any) => {
              const depatName = item.empDept || item["Department Name"];

              if (!acc[depatName]) {
                acc[depatName] = {
                  xAxisValueData: depatName,
                  seriesValueOneData: 0, // Employee count
                  seriesValueTwoData: 0, // Confirmation count
                  seriesValueThreeData: 0 // Extension count
                };
              }

              // Employee Details
              if (item.empDept) {
                if (!item.probationDetailId) {
                  acc[depatName].seriesValueOneData += 1;
                }
              }

              // Response Data (aggregated)
              if (item["Department Name"]) {
                acc[depatName].seriesValueTwoData += item["Confirmation"] || 0;
                acc[depatName].seriesValueThreeData += item["Extension"] || 0;
              }

              return acc;
            }, {})
          );



          this.departmentDataForFourthGraph = transformedData;
          transformedData.xAxisName = 'Department';
          transformedData.yAxisName = 'Department Count';
          transformedData.seriesLabelOne = 'Probation';
          transformedData.seriesLabelTwo = 'Confirmation';
          transformedData.seriesLabelThree = 'Extension';


          if (graphtype == 'bar') {
            this.elcmBarChartActive(transformedData, 'fourth-elcm-chart', 'three');
          }
          if (graphtype == 'line') {
            this.elcmLineChartActive(transformedData, 'fourth-elcm-chart', 'three');
          }



        })
    } else {
      this.hodAndManagerGraph(graphtype);
    }
  }
  selectedDepartment: any = []
  onSelectDepartment() {
    if (this.selectedDepartment.length > 0) {
      this.exitGraph(this.isElcmTypeIcon4)

    }
  }

  onDeSelectDepartment() {
    this.exitGraph(this.isElcmTypeIcon4)


  }



  selectAllDepartment(items: any): void {
    this.selectedDepartment = items;
    this.exitGraph(this.isElcmTypeIcon4)
  }

  onDeSelectAllDepartment() {
    this.selectedDepartment = [];

    this.exitGraph(this.isElcmTypeIcon4)

  }
  selectDepartmentFortermination: any = []
  exitGraphTableDate: any = [];
  getChartApiDD: any = []
  terminationMonth: any
  exitGraph(graphtype: any) {
    let url;


    url = `${this.config.getTerminationgraph}`

    const names = this.selectedDepartment.map((dept: any) => dept.name);

    console.log(names)

    const payload = {
      companyId: this.loggedInUserCompanyID,
      year: this.selectedYeargraph6,
      fiscalYear: this.loggedInCompanyFiscalyear, // or dynamically assign if needed
      departments: names.length > 0 ? names : null, // wrap in array
      month: this.terminationMonth || null,
      managerCode: this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' ? this.loggedInUserEmployeeCode : null, // optional: dynamically set if required
      hodCode: this.loggedInUserRole == 'HOD' ? this.loggedInUserEmployeeCode : null
    };


    this.httpService.callPostService(url, payload)
      .subscribe((response: any) => {
        // Step 1: Convert object to array
        console.log('getTerminationgraph ------------------------ ', response)
        this.getChartApiDD = response?.data;
        let filterData: any = []
        if (response) {

          filterData = response?.data?.filter((elm: any) => elm.exitedEmployeeCount != 0 || elm.terminationCount != 0 || elm.resignationCount != 0)



          const transformedData: ChartDataArray = filterData.map((item: any) => ({
            xAxisValueData: item.Department,
            seriesValueOneData: item.resignationCount,
            seriesValueTwoData: item.exitedEmployeeCount,
            seriesValueThreeData: item.terminationCount,
          }));
          this.exitGraphTableDate = transformedData;

          transformedData.xAxisName = 'Department Name';
          transformedData.yAxisName = 'Department Count';
          transformedData.seriesLabelOne = 'Resigned';
          transformedData.seriesLabelTwo = 'Exited';
          transformedData.seriesLabelThree = 'Terminated';


          const transformedDataHODManager: ChartDataArray = filterData.map((item: any) => ({
            xAxisValueData: item.Department,
            seriesValueOneData: item.resignationCount,
            seriesValueTwoData: item.exitedEmployeeCount,

          }));
          ''
          transformedDataHODManager.xAxisName = 'Department Name';
          transformedDataHODManager.yAxisName = 'Department Count';
          transformedDataHODManager.seriesLabelOne = 'Resigned';
          transformedDataHODManager.seriesLabelTwo = 'Exited';


          this.departmentDataForThirdGraph = transformedData;
          if (this.loggedInUserRole !== 'Manager' && this.loggedInUserRole !== 'HOD') {

            if (graphtype === 'bar') {
              this.elcmBarChartActive(transformedData, 'exit-elcm-chart', 'three');
            } else if (graphtype === 'line') {
              this.elcmLineChartActive(transformedData, 'exit-elcm-chart', 'three');
            }
          } else {

            if (graphtype === 'bar') {
              this.elcmBarChartActive(transformedDataHODManager, 'exit-elcm-chart', 'three');
            } else if (graphtype === 'line') {
              this.elcmLineChartActive(transformedDataHODManager, 'exit-elcm-chart', 'three');
            }
          }
        }

      })


  }
  currentemployeesProbationDetails: any = [];
  currentemployeesConfirmantionDetails: any = []

  EmployeeSummaryData: any = [];

  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.EmployeeSummaryData = data.data;
      // this.hodAndManagerGraph()
    })
  }
  getProbationList() {
    this.httpService.callGetService(`${this.config.getProbationDetailsConfirmationEmployee}/${this.loggedInUserCompanyID}`)
      .subscribe((response: any) => {
        if (!response || !response?.data) return;

        this.currentemployeesConfirmantionDetails = response?.data.filter((elm: any) => elm.hodCode === this.loggedInUserEmpCode);
        console.log("cbvxcvxcv", this.currentemployeesConfirmantionDetails);

      })
  }

  dropdowndata: any = []
  dd1: any = [];
  dd2: any = [];
  dd3: any = [];

  filterDataForConfirmatrion: any = []
  filterDataForExtention: any = []
  filterDataprobationListForHOD: any = []
  filterDataForConfirmatrionManager: any = []
  filterDataForExtentionManager: any = []
  filterDataprobationListForManager: any = []
  filterDataprobationListForManagerAndHod: any = []
  filterDataForConfirmatrionManagerAndHod: any = []
  filterDataForExtentionManagerAndHod: any = []


  //  --------------------------------------------------According to month --------------------------------------------------------------

  // hodAndManagerGraph(graphType: any) {
  //   this.httpService.callGetService(`${this.config.getProbationDetailsConfirmationEmployee}/${this.loggedInUserCompanyID}`)

  //     .subscribe((response: any) => {
  //       this.filterDataForConfirmatrion = [];
  //       this.filterDataForConfirmatrionManager = []
  //       if (!response || !response?.data) return;

  //       // this.filterDataForConfirmatrion = response.data.filter((elm: any) => elm.hodCode === this.loggedInUserEmpCode);
  //       // this.filterDataForConfirmatrionManager = response.data.filter((elm: any) => elm.reportingManagerCode === this.loggedInUserEmpCode);
  //       this.filterDataForConfirmatrion = response.data.filter((elm: any) => {
  //         const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //         return elm.hodCode === this.loggedInUserEmpCode && joiningMonth === this.fromDate5;
  //       });

  //       this.filterDataForConfirmatrionManager = response.data.filter((elm: any) => {
  //         const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //         return elm.reportingManagerCode === this.loggedInUserEmpCode && joiningMonth === this.fromDate5;
  //       });

  //       this.filterDataForConfirmatrionManagerAndHod = response.data.filter((elm: any) => {
  //         const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //         return ((elm.reportingManagerCode === this.loggedInUserEmpCode && elm.hodCode === this.loggedInUserEmpCode)||elm.reportingManagerCode==this.loggedInUserEmpCode)&& joiningMonth === this.fromDate5;
  //       });
  //       console.log(this.filterDataForConfirmatrionManager);

  //     })
  //   this.httpService.callGetService(`${this.config.getProbationDetailsWithConfirmationDate}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYeargraph5}`)
  //     .subscribe((response: any) => {
  //       this.filterDataForExtention = [];
  //       this.filterDataForExtentionManager = []
  //       if (!response || !response?.data) return;

  //       // this.filterDataForExtention = response.data.filter((elm: any) => elm.hodCode === this.loggedInUserEmpCode && elm.probationStatus == 'Extension');
  //       // this.filterDataForExtentionManager = response.data.filter((elm: any) => elm.reportingManagerCode === this.loggedInUserEmpCode && elm.probationStatus == 'Extension');
  //       this.filterDataForExtention = response.data.filter((elm: any) => {
  //         const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //         return elm.hodCode === this.loggedInUserEmpCode &&
  //           elm.probationStatus == 'Extension' &&
  //           joiningMonth === this.fromDate5;
  //       });

  //       this.filterDataForExtentionManager = response.data.filter((elm: any) => {
  //         const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //         return elm.reportingManagerCode === this.loggedInUserEmpCode &&
  //           elm.probationStatus == 'Extension' &&
  //           joiningMonth === this.fromDate5;
  //       });
  //       this.filterDataForExtentionManagerAndHod = response.data.filter((elm: any) => {
  //         const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //         return ((elm.reportingManagerCode === this.loggedInUserEmpCode && elm.hodCode === this.loggedInUserEmpCode)||elm.reportingManagerCode==this.loggedInUserEmpCode)&& joiningMonth === this.fromDate5;
  //       });

  //     })
  //   this.httpService.callGetService(`${this.config.getProbationDetails}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYeargraph5}&fiscalType=${this.loggedInCompanyFiscalyear}`).subscribe((response: any) => {
  //     this.filterDataprobationListForHOD = [];
  //     this.filterDataprobationListForManager = [];
  //     if (!response || !response?.data) return;
  //     let probationListForHOD = response?.data;
  //     // this.filterDataprobationListForHOD = probationListForHOD.filter((elm: any) => elm.hodCode === this.loggedInUserEmpCode);
  //     // this.filterDataprobationListForManager = probationListForHOD.filter((elm: any) => elm.reportingManagerCode === this.loggedInUserEmpCode);
  //     this.filterDataprobationListForHOD = probationListForHOD.filter((elm: any) => {
  //       const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //       return elm.hodCode === this.loggedInUserEmpCode && joiningMonth === this.fromDate5 && this.loggedInUserRole=='HOD';
  //     });

  //     this.filterDataprobationListForManager = probationListForHOD.filter((elm: any) => {
  //       const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //       return elm.reportingManagerCode === this.loggedInUserEmpCode && joiningMonth === this.fromDate5  && this.loggedInUserRole=='Manager';
  //     });
  //     this.filterDataprobationListForManagerAndHod = probationListForHOD.filter((elm: any) => {
  //       const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //       return ((elm.reportingManagerCode === this.loggedInUserEmpCode && elm.hodCode === this.loggedInUserEmpCode)||elm.reportingManagerCode==this.loggedInUserEmpCode)&& joiningMonth === this.fromDate5;
  //     });
  //     let CommanData: any = []


  //     if (this.loggedInUserRole == 'HOD' && this.httpService.confirmationProbationWhomSetup == 'HOD') {
  //       console.log("inside HOD");

  //       this.filterDataprobationListForHOD.forEach((elm: any) => {
  //         if (!this.departmentDataForFourthGraph.includes(elm.empDept)) {
  //           this.departmentDataForFourthGraph.push(elm.empDept);
  //         }
  //       });

  //       if (this.selectDepartmentForFourthGraph) {

  //         let selectedMonth = this.fromDate5;
  //         let filterDataprobationListForHOD = this.filterDataprobationListForHOD.filter(
  //           (elm: any) =>
  //             elm.empDept === this.selectDepartmentForFourthGraph &&
  //             new Date(elm.createdAt).getMonth() + 1 === selectedMonth
  //         );

  //         let filterDataForConfirmatrion = this.filterDataForConfirmatrion.filter(
  //           (elm: any) =>
  //             elm.empDept === this.selectDepartmentForFourthGraph &&
  //             new Date(elm.createdAt).getMonth() + 1 === selectedMonth
  //         );

  //         let filterDataForExtention = this.filterDataForExtention.filter(
  //           (elm: any) =>
  //             elm.empDept === this.selectDepartmentForFourthGraph &&
  //             new Date(elm.createdAt).getMonth() + 1 === selectedMonth
  //         );
  //         CommanData = [
  //           ...filterDataprobationListForHOD,
  //           ...filterDataForConfirmatrion,
  //           ...filterDataForExtention
  //         ];
  //       } else {
  //         CommanData = [
  //           ...this.filterDataprobationListForHOD,
  //           ...this.filterDataForConfirmatrion,
  //           ...this.filterDataForExtention
  //         ];
  //       }

  //     }
  //     else if (this.filterDataprobationListForManagerAndHod.length>0 && this.confirmationProbationWhomSetup == 'LINE_MANAGER') {
  //       console.log("inside HOD and manager");

  //       this.filterDataprobationListForManagerAndHod.forEach((elm: any) => {
  //         if (!this.departmentDataForFourthGraph.includes(elm.empDept)) {
  //           this.departmentDataForFourthGraph.push(elm.empDept);
  //         }
  //       });

  //       if (this.selectDepartmentForFourthGraph) {

  //         let selectedMonth = this.fromDate5;
  //         let filterDataprobationListForManagerAndHod = this.filterDataprobationListForManagerAndHod.filter(
  //           (elm: any) =>
  //             elm.empDept === this.selectDepartmentForFourthGraph &&
  //             new Date(elm.createdAt).getMonth() + 1 === selectedMonth
  //         );

  //         let filterDataForConfirmatrion = this.filterDataForConfirmatrionManagerAndHod.filter(
  //           (elm: any) =>
  //             elm.empDept === this.selectDepartmentForFourthGraph &&
  //             new Date(elm.createdAt).getMonth() + 1 === selectedMonth
  //         );

  //         let filterDataForExtention = this.filterDataForExtentionManagerAndHod.filter(
  //           (elm: any) =>
  //             elm.empDept === this.selectDepartmentForFourthGraph &&
  //             new Date(elm.createdAt).getMonth() + 1 === selectedMonth
  //         );
  //         CommanData = [
  //           ...filterDataprobationListForManagerAndHod,
  //           ...filterDataForConfirmatrion,
  //           ...filterDataForExtention
  //         ];
  //       } else {
  //         CommanData = [
  //           ...this.filterDataprobationListForManagerAndHod,
  //           ...this.filterDataForConfirmatrionManagerAndHod,
  //           ...this.filterDataForExtention
  //         ];
  //       }

  //     } 
  //     else {
  //       console.log(this.filterDataprobationListForManager);

  //       this.filterDataprobationListForManager.forEach((elm: any) => {
  //         if (!this.departmentDataForFourthGraph.includes(elm.empDept)) {
  //           this.departmentDataForFourthGraph.push(elm.empDept);
  //         }
  //       });


  //       if (this.selectDepartmentForFourthGraph != undefined) {
  //         let filterDataprobationListForManager = this.filterDataprobationListForManager.filter(
  //           (elm: any) => elm.empDept == this.selectDepartmentForFourthGraph
  //         );
  //         const filteredEmployees = filterDataprobationListForManager.filter((emp: any) => {
  //           const month = new Date(emp.createdAt).getMonth() + 1;
  //           return month === this.fromDate5;
  //         });

  //         let filterDataForConfirmatrion = this.filterDataForConfirmatrionManager.filter(
  //           (elm: any) => elm.empDept == this.selectDepartmentForFourthGraph
  //         );
  //         const filterDataForConfirmatrionManager = filterDataForConfirmatrion.filter((emp: any) => {
  //           const month = new Date(emp.createdAt).getMonth() + 1;
  //           return month === this.fromDate5;
  //         });

  //         let filterDataForExtention = this.filterDataForExtention.filter(
  //           (elm: any) => elm.empDept == this.selectDepartmentForFourthGraph
  //         )
  //         const filterDataForExtentionManager = filterDataForExtention.filter((emp: any) => {
  //           const month = new Date(emp.createdAt).getMonth() + 1;
  //           return month === this.fromDate5;
  //         });

  //         CommanData = [...filteredEmployees, ...filterDataForConfirmatrionManager, ...filterDataForExtentionManager];
  //       } else {
  //         const filteredEmployees = this.filterDataprobationListForManager.filter((emp: any) => {
  //           const month = new Date(emp.createdAt).getMonth() + 1;
  //           return month === this.fromDate5;
  //         });
  //         const filterDataForConfirmatrionManager = this.filterDataForConfirmatrionManager.filter((emp: any) => {
  //           const month = new Date(emp.createdAt).getMonth() + 1;
  //           return month === this.fromDate5;
  //         }); const filterDataForExtentionManager = this.filterDataForExtentionManager.filter((emp: any) => {
  //           const month = new Date(emp.createdAt).getMonth() + 1;
  //           return month === this.fromDate5;
  //         });

  //         CommanData = [...filteredEmployees, ...filterDataForConfirmatrionManager, ...filterDataForExtentionManager];
  //       }

  //     }




  //     const transformedData: TransformedData = Object.values(
  //       CommanData.reduce((acc: any, item: any) => {
  //         const assetName = item.empDept;
  //         if (!acc[assetName]) {
  //           acc[assetName] = {
  //             xAxisValueData: assetName,
  //             seriesValueOneData: 0,
  //             seriesValueTwoData: 0,
  //             seriesValueThreeData: 0
  //           };
  //         }
  //         if (!item.probationDetailId) {

  //           acc[assetName].seriesValueOneData += 1; // Increment employee count for the asset
  //         }
  //         if (item.probationStatus == "Confirmation") {
  //           acc[assetName].seriesValueTwoData += 1; // Count only confirmed employees
  //         }
  //         if (item.probationStatus == "Extension") {
  //           acc[assetName].seriesValueThreeData += 1; // Count only confirmed employees
  //         }

  //         return acc;
  //       }, {})
  //     );

  //     this.departmentDataForFourthGraphDD = transformedData;
  //     transformedData.xAxisName = 'Department';
  //     transformedData.yAxisName = 'Department Count';
  //     transformedData.seriesLabelOne = 'Probation';
  //     transformedData.seriesLabelTwo = 'Confirmation';
  //     transformedData.seriesLabelThree = 'Extension';
  //     console.log(transformedData)
  //     if (graphType == 'bar') {
  //       this.elcmBarChartActive(transformedData, 'fourth-elcm-chart', 'three');
  //     }
  //     if (graphType == 'line') {
  //       this.elcmLineChartActive(transformedData, 'fourth-elcm-chart', 'three');
  //     }
  //     this.manageeveryTabCount()
  //   })



  // }

  //  --------------------------------------------------According to month --------------------------------------------------------------


  hodAndManagerGraph(graphType: any) {
    this.httpService.callGetService(`${this.config.getProbationDetailsConfirmationEmployee}/${this.loggedInUserCompanyID}`)

      .subscribe((response: any) => {
        this.filterDataForConfirmatrion = [];
        this.filterDataForConfirmatrionManager = []
        if (!response || !response?.data) return;

        // this.filterDataForConfirmatrion = response.data.filter((elm: any) => elm.hodCode === this.loggedInUserEmpCode);
        // this.filterDataForConfirmatrionManager = response.data.filter((elm: any) => elm.reportingManagerCode === this.loggedInUserEmpCode);
        console.log(response.data);

        this.filterDataForConfirmatrion = response?.data?.filter((elm: any) => {
          const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
          return elm.hodCode === this.loggedInUserEmpCode
        });

        console.log(this.filterDataForConfirmatrion);


        this.filterDataForConfirmatrionManager = response?.data?.filter((elm: any) => {
          const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
          return elm.reportingManagerCode === this.loggedInUserEmpCode
        });

        this.filterDataForConfirmatrionManagerAndHod = response?.data?.filter((elm: any) => {
          const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
          return ((elm.reportingManagerCode === this.loggedInUserEmpCode && elm.hodCode === this.loggedInUserEmpCode)
            || elm.reportingManagerCode == this.loggedInUserEmpCode);
        });
        this.dd1 = [... this.filterDataForConfirmatrion, ... this.filterDataForConfirmatrionManager, ... this.filterDataForConfirmatrionManagerAndHod]

      })
    this.httpService.callGetService(`${this.config.getProbationDetailsWithConfirmationDate}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYeargraph5}`)
      .subscribe((response: any) => {
        this.filterDataForExtention = [];
        this.filterDataForExtentionManager = []
        if (!response || !response?.data) return;

        // this.filterDataForExtention = response.data.filter((elm: any) => elm.hodCode === this.loggedInUserEmpCode && elm.probationStatus == 'Extension');
        // this.filterDataForExtentionManager = response.data.filter((elm: any) => elm.reportingManagerCode === this.loggedInUserEmpCode && elm.probationStatus == 'Extension');
        this.filterDataForExtention = response.data.filter((elm: any) => {
          const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
          return elm.hodCode === this.loggedInUserEmpCode && elm.probationStatus == 'Extension' && this.loggedInUserRole == 'HOD' && this.confirmationProbationWhomSetup == 'HOD';
        });


        this.filterDataForExtentionManager = response.data
          .filter((elm: any) =>
            elm.reportingManagerCode === this.loggedInUserEmpCode &&
            elm.probationStatus === 'Extension' &&
            this.loggedInUserRole === 'Manager'
          )
          .filter((employee: { empName: string; }, index: any, self: any[]) =>
            index === self.findIndex(
              (e) => e.empName?.trim().toLowerCase() === employee.empName?.trim().toLowerCase()
            )
          );



        this.filterDataForExtentionManagerAndHod = response.data.filter((elm: any) => {
          const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
          return ((elm.reportingManagerCode === this.loggedInUserEmpCode && elm.hodCode === this.loggedInUserEmpCode && this.confirmationProbationWhomSetup == 'LINE_MANAGER' && this.loggedInUserRole == 'HOD' && elm.probationStatus == 'Extension') || elm.reportingManagerCode == this.loggedInUserEmpCode && this.confirmationProbationWhomSetup == 'LINE_MANAGER' && this.loggedInUserRole == 'HOD' && elm.probationStatus == 'Extension');
        });
        console.log("--------------------------------------------------");

        console.log(this.filterDataForExtention);
        console.log(this.filterDataForExtentionManager);
        console.log(this.filterDataForExtentionManagerAndHod);
        this.dd2 = [...this.filterDataForExtention, ...this.filterDataForExtentionManager, ...this.filterDataForExtentionManagerAndHod]
      })


    this.httpService.callGetService(`${this.config.getProbationDetails}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYeargraph5}&fiscalType=${this.loggedInCompanyFiscalyear}`).subscribe((response: any) => {
      this.filterDataprobationListForHOD = [];
      this.filterDataprobationListForManager = [];
      if (!response || !response?.data) return;
      let probationListForHOD = response?.data;
      // this.filterDataprobationListForHOD = probationListForHOD.filter((elm: any) => elm.hodCode === this.loggedInUserEmpCode);
      // this.filterDataprobationListForManager = probationListForHOD.filter((elm: any) => elm.reportingManagerCode === this.loggedInUserEmpCode);
      this.filterDataprobationListForHOD = probationListForHOD.filter((elm: any) => {
        const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
        return elm.hodCode === this.loggedInUserEmpCode && this.loggedInUserRole == 'HOD' && this.confirmationProbationWhomSetup == 'HOD';
      });

      this.filterDataprobationListForManager = probationListForHOD.filter((elm: any) => {
        const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
        return elm.reportingManagerCode === this.loggedInUserEmpCode && this.loggedInUserRole == 'Manager';
      });
      this.filterDataprobationListForManagerAndHod = probationListForHOD.filter((elm: any) => {
        const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
        return ((elm.reportingManagerCode === elm.hodCode) || elm.reportingManagerCode == this.loggedInUserEmpCode);
      });
      this.dd3 = [...  this.filterDataprobationListForHOD, ...this.filterDataprobationListForManager, ...this.filterDataprobationListForManagerAndHod]


      let CommanData: any = []


      if (this.loggedInUserRole == 'HOD' && this.httpService.confirmationProbationWhomSetup == 'HOD') {
        console.log("inside HOD");

        this.filterDataprobationListForHOD.forEach((elm: any) => {
          if (!this.departmentDataForFourthGraph.includes(elm.empDept)) {
            this.departmentDataForFourthGraph.push(elm.empDept);
          }
        });

        if (this.selectDepartmentForFourthGraph) {

          let selectedMonth = this.fromDate5;
          let filterDataprobationListForHOD = this.filterDataprobationListForHOD.filter(
            (elm: any) =>
              elm.empDept === this.selectDepartmentForFourthGraph
          );
          this.filterDataprobationListForHOD = filterDataprobationListForHOD;
          let filterDataForConfirmatrion = this.filterDataForConfirmatrion.filter(
            (elm: any) =>
              elm.empDept === this.selectDepartmentForFourthGraph
          );
          this.filterDataForConfirmatrion = filterDataForConfirmatrion;
          let filterDataForExtention = this.filterDataForExtention.filter(
            (elm: any) =>
              elm.empDept === this.selectDepartmentForFourthGraph
          );
          this.filterDataForExtention = filterDataForExtention;
          CommanData = [
            ...filterDataprobationListForHOD,
            ...filterDataForConfirmatrion,
            ...filterDataForExtention
          ];
        } else {
          CommanData = [
            ...this.filterDataprobationListForHOD,
            ...this.filterDataForConfirmatrion,
            ...this.filterDataForExtention
          ];
        }

      }
      else if (this.filterDataprobationListForManagerAndHod.length > 0 && this.confirmationProbationWhomSetup == 'LINE_MANAGER' && this.loggedInUserRole !== 'Manager') {
        console.log("inside HOD and manager");

        this.filterDataprobationListForManagerAndHod.forEach((elm: any) => {
          if (!this.departmentDataForFourthGraph.includes(elm.empDept)) {
            this.departmentDataForFourthGraph.push(elm.empDept);
          }
        });

        if (this.selectDepartmentForFourthGraph) {

          let selectedMonth = this.fromDate5;
          let filterDataprobationListForManagerAndHod = this.filterDataprobationListForManagerAndHod.filter(
            (elm: any) =>
              elm.empDept === this.selectDepartmentForFourthGraph
          );
          this.filterDataprobationListForManagerAndHod = filterDataprobationListForManagerAndHod;
          let filterDataForConfirmatrion = this.filterDataForConfirmatrionManagerAndHod.filter(
            (elm: any) =>
              elm.empDept === this.selectDepartmentForFourthGraph
          );
          this.filterDataForConfirmatrionManagerAndHod = filterDataForConfirmatrion;
          let filterDataForExtention = this.filterDataForExtentionManagerAndHod.filter(
            (elm: any) =>
              elm.empDept === this.selectDepartmentForFourthGraph
          );
          this.filterDataForExtentionManagerAndHod = filterDataForExtention;
          CommanData = [
            ...filterDataprobationListForManagerAndHod,
            ...filterDataForConfirmatrion,
            ...filterDataForExtention
          ];
        } else {
          CommanData = [
            ...this.filterDataprobationListForManagerAndHod,
            ...this.filterDataForConfirmatrionManagerAndHod,
            ...this.filterDataForExtention
          ];
        }

      }
      else {
        console.log(this.filterDataprobationListForManager);
        console.log("inside manager");

        this.filterDataprobationListForManager.forEach((elm: any) => {
          if (!this.departmentDataForFourthGraph.includes(elm.empDept)) {
            this.departmentDataForFourthGraph.push(elm.empDept);
          }
        });


        if (this.selectDepartmentForFourthGraph != undefined) {
          let filterDataprobationListForManager = this.filterDataprobationListForManager.filter(
            (elm: any) => elm.empDept == this.selectDepartmentForFourthGraph
          );
          this.filterDataprobationListForManager = filterDataprobationListForManager;
          const filteredEmployees = filterDataprobationListForManager;

          let filterDataForConfirmatrion = this.filterDataForConfirmatrionManager.filter(
            (elm: any) => elm.empDept == this.selectDepartmentForFourthGraph
          );
          this.filterDataForConfirmatrionManager = filterDataForConfirmatrion;
          const filterDataForConfirmatrionManager = filterDataForConfirmatrion;

          let filterDataForExtention = this.filterDataForExtentionManager.filter(
            (elm: any) => elm.empDept == this.selectDepartmentForFourthGraph
          )
          this.filterDataForExtentionManager = filterDataForExtention;
          const filterDataForExtentionManager = filterDataForExtention;

          CommanData = [...filteredEmployees, ...filterDataForConfirmatrionManager, ...filterDataForExtentionManager];
        } else {


          let uniqueEmployees = this.filterDataForExtentionManager.filter(
            (employee: { empName: string; }, index: any, self: any[]) =>
              index === self.findIndex(
                (e) => e.empName?.trim().toLowerCase() === employee.empName?.trim().toLowerCase()
              )
          );




          const filteredEmployees = this.filterDataprobationListForManager;
          const filterDataForConfirmatrionManager = this.filterDataForConfirmatrionManager;
          const filterDataForExtentionManager = uniqueEmployees;
          CommanData = [...filteredEmployees, ...filterDataForConfirmatrionManager, ...filterDataForExtentionManager];
        }

      }



      let combinedataforDD: any = [...this.dd1, ...this.dd2, ...this.dd3];
      this.departmentDataForFourthGraphDD = []
      console.log(combinedataforDD);

      combinedataforDD.forEach((elm: any) => {
        if (elm?.empDept) { // Ensure empDept exists
          const deptName = elm.empDept.trim().toLowerCase(); // Normalize department name

          // Debugging: Log to verify department names
          console.log("Checking Department:", deptName);

          // Check if department already exists in the list
          if (!this.departmentDataForFourthGraphDD.some(
            (candidate: any) => candidate.xAxisValueData.trim().toLowerCase() === deptName
          )) {
            this.departmentDataForFourthGraphDD.push({
              id: deptName, // Store normalized name
              xAxisValueData: elm.empDept.trim(), // Keep original case for display
            });
          }
        }
      });
      console.log(this.departmentDataForFourthGraphDD);


      console.log("CommanData", CommanData);


      const transformedData: TransformedData = Object.values(
        CommanData.reduce((acc: any, item: any) => {
          const assetName = item.empDept;
          console.log(assetName);

          if (!acc[assetName]) {
            acc[assetName] = {
              xAxisValueData: assetName,
              seriesValueOneData: 0,
              seriesValueTwoData: 0,
              seriesValueThreeData: 0
            };
          }
          if (!item.probationDetailId) {

            acc[assetName].seriesValueOneData += 1; // Increment employee count for the asset
          }
          if (item.probationStatus == "Confirmation") {
            acc[assetName].seriesValueTwoData += 1; // Count only confirmed employees
          }
          if (item.probationStatus == "Extension") {
            acc[assetName].seriesValueThreeData += 1; // Count only confirmed employees
          }

          return acc;
        }, {})
      );


      transformedData.xAxisName = 'Department';
      transformedData.yAxisName = 'Department Count';
      transformedData.seriesLabelOne = 'Probation';
      transformedData.seriesLabelTwo = 'Confirmation';
      transformedData.seriesLabelThree = 'Extension';
      console.log(transformedData)
      if (graphType == 'bar') {
        this.elcmBarChartActive(transformedData, 'fourth-elcm-chart', 'three');
      }
      if (graphType == 'line') {
        this.elcmLineChartActive(transformedData, 'fourth-elcm-chart', 'three');
      }
      this.departmentDataForFourthGraph = transformedData;
      this.manageeveryTabCount()
    })



  }
  counterModuleForHODAndManager: any = []
  manageeveryTabCount() {
    this.counterModule.forEach((module: any) => {


      switch (module.ModuleName) {
        case 'Emp. appl. filled by candidate vs sent by HR':
          module.totalCount = `${this.employyeApplicationFromdata?.FilledCandidateCount ?? 0}/${this.employyeApplicationFromdata?.CandidateCount ?? 0}`;
          break;
        case 'Emp. appl. filled by HR vs filled by candidate':
          module.totalCount = `${this.employyeApplicationFromdata?.CandidateCount ?? 0}/${this.employyeApplicationFromdata?.FilledCandidateCount ?? 0}`;
          break;
        case 'Offer letter sent by HR vs. emp. appl. filled by HR':
          module.totalCount = `${this.employyeApplicationFromdata?.OfferLetterCount ?? 0}/${this.employyeApplicationFromdata?.HRFilledCount ?? 0}`;
          break;
        case 'Cand. joined and appointment letter issued vs offer letter sent by HR':
          module.totalCount = `${this.employyeApplicationFromdata?.AppointmentLetterCount ?? 0}/${this.employyeApplicationFromdata?.OfferLetterCount ?? 0}`;
          break;
        case 'On probation':
          module.totalCount = this.probationCount || '0';
          break;
        case 'Probation Extended':
          module.totalCount = this.employyeApplicationFromdata?.ExtensionCount || 0;;
          break;
        case 'Confirmed':
          module.totalCount = this.employyeApplicationFromdata?.ConfirmationCount || 0;
          break;
        case 'Resigned Emp':
          module.totalCount = this.filteredResignations?.length || 0;
          break;
        case 'Regrettable Emp':
          const regrateLength = this.regrateCount?.length ?? 0;
          const resignLength = this.filteredResignations?.length ?? 0;
          module.totalCount = `${regrateLength}/${resignLength}`;
          // module.totalCount = this.regrateCount?.length + "/" + this.filteredResignations?.length || 0;
          break;
        case 'Resignation Accepted Emp':
          // module.totalCount = this.resignationAcceptedCount?.length + "/" + this.filteredResignations?.length || 0;
          const acceptedCount = this.resignationAcceptedCount?.length ?? 0;
          const totalResignations = this.filteredResignations?.length ?? 0;
          module.totalCount = `${acceptedCount}/${totalResignations}`;
          break;
        case 'Terminated Emp':
          module.totalCount = this.terminatedCount?.length || 0;
          break;
      }
    });

    const finalModuleList = this.CheckArrayLength1 === 0 ? this.forExit : this.counterModuleForHODAndManager1;
    finalModuleList.forEach((module: any) => {
      switch (module.ModuleName) {
        case 'On probation':
          module.totalCount = (this.filterDataprobationListForHOD.length || this.filterDataprobationListForManager.length || this.filterDataprobationListForManagerAndHod.length) ?? 0;
          break;
        case 'Probation Extended':
          module.totalCount = (this.filterDataForExtention.length || this.filterDataForExtentionManager.length || this.filterDataForExtentionManagerAndHod.length) ?? 0;;
          break;
        case 'Confirmed':
          module.totalCount = (this.filterDataForConfirmatrion.length || this.filterDataForConfirmatrionManager.length || this.filterDataForConfirmatrionManagerAndHod.length) ?? 0;
          break;
        case 'Resigned Emp':
          module.totalCount = this.filteredResignations?.length || 0;
          break;
        case 'Regrettable Emp':
          // module.totalCount = this.regrateCount?.length + "/" + this.filteredResignations?.length || 0;
          const regrateLength = this.regrateCount?.length ?? 0;
          const resignLength = this.filteredResignations?.length ?? 0;
          module.totalCount = `${regrateLength}/${resignLength}`;
          break;
        case 'Resignation Accepted Emp':
          const acceptedCount = this.resignationAcceptedCount?.length ?? 0;
          const totalResignations = this.filteredResignations?.length ?? 0;
          module.totalCount = `${acceptedCount}/${totalResignations}`;
          break;
        case 'Terminated Emp':
          module.totalCount = this.terminatedCount?.length || 0;
          break;
      }
    });
    this.counterModuleForHODAndManager = finalModuleList;
  }

  // Usage for Line Chart
  elcmLineChartActive(data: any, idSelector: any, graphType: any): void {
    const createchart = createChart(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
    setTimeout(() => {
      this.mobileResponsiveService.chartResizeFn(createchart);
    }, 800);
  }

  // Usage for Bar Chart
  elcmBarChartActive(data: any, idSelector: any, graphType: any): void {
    const createchart = createChart(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
    setTimeout(() => {
      this.mobileResponsiveService.chartResizeFn(createchart);
    }, 800);
  }

  // -------------------------------------------------------------------Exit-------------------------------------------------------------------------------
  checkAuthority: any;

  terminationEmployeeList: any = []
  currentterminationEmployeeList: any = []
  terminatedUserId: any;
  getterminationFormData() {
    this.httpService.callGetService(`${this.config.getTerminationAllForm}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYear}`).subscribe((record: any) => {
      let allData = record?.data;

      if (this.loggedInUserRole == 'Admin') allData = this.elcmGenericService.empFilterForAllEmployeeList(allData, this.adminAccessData?.employeeDetails, 'userId');


      this.terminationEmployeeList = allData;
      this.currentterminationEmployeeList = allData;
      this.terminatedUserId = allData.filter((elm: any) => elm.userId == this.loggedInUserId && elm.revolveStatus == false);
      this.filterByFiscalMonthRange(this.fromDate)
    })
  }
  dropDownForExit: any = []
  getExitFormData() {
    this.httpService.callGetService(`${this.config.getExitAllForm}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYear}`).subscribe((record: any) => {
      const recordData = record?.data;
      var userlist;

      setTimeout(() => {
        this.checkAuthority = this.httpService.selectedOptionForExitPermission;
        const isAdminRole = ['HR Admin', 'Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(this.loggedInUserRole);

        userlist = recordData.map((user: any) => {
          const match = this.terminationEmployeeList.find((emp: any) => emp.userId == user.userId && emp.revolveStatus == false);
          return {
            ...user,
            terminationFormId: match?.terminationFormId || null
          };
        });
        console.log(this.getChartApiDD);
        let chartDept = this.getChartApiDD.map((elm: any) => {
          return {
            empDepartment: elm.Department
          }
        })
        if (this.loggedInUserRole == 'Admin') userlist = this.elcmGenericService.empFilterForAllEmployeeList(userlist, this.adminAccessData?.employeeDetails, 'userId');

        const departmentDropDown = [...userlist, ...this.terminationEmployeeList, ...chartDept]

        console.log(departmentDropDown);


        this.dropDownForExit = []
        departmentDropDown.forEach((elm: any) => {
          if (elm?.empDepartment) { // Ensure department is not undefined or null
            const deptName = elm.empDepartment.trim().toLowerCase(); // Normalize department name
            console.log("deptName", deptName);

            // Debugging: Log to verify department names
            console.log("Checking Department:", deptName);

            // Check if department already exists in the list
            if (!this.dropDownForExit.some((candidate: any) => candidate.name.trim().toLowerCase() === deptName)) {
              this.dropDownForExit.push({
                id: elm.empDepartment, // Store normalized name
                name: elm.empDepartment.trim(), // Keep original case for display
              });
            }
          }
          console.log(this.dropDownForExit);

        });




        if (

          this.checkAuthority == 'HOD_AND_HR' &&
          !isAdminRole
        ) {
          console.log("inside hod +++++++++++++++++++++++++++++++++++");
          console.log(userlist);
          console.log(this.loggedInUserId);
          let data = userlist.filter((elm: any) =>
            this.loggedInUserEmployeeCode === elm.hodCode &&
            elm.managerCode !== elm.hodCode &&
            elm.userId != this.loggedInUserId
          );
          this.listofFromData = data;
          this.currentlistofFromData = data

        } else if (

          this.checkAuthority == 'MANAGER_AND_HR' &&
          !isAdminRole
        ) {
          console.log("inside Manager");
          console.log(userlist);

          let data = userlist.filter((elm: any) => this.loggedInUserEmployeeCode == elm.managerCode && elm.userId != this.loggedInUserId);

          this.listofFromData = data;
          this.currentlistofFromData = data

        }
        else if (

          this.checkAuthority == 'HOD_AND_MANAGER_AND_HR' &&
          !isAdminRole
        ) {
          console.log("inside HOD_AND_MANAGER_AND_HR");
          console.log(userlist);
          console.log(this.loggedInUserId);
          let data
          if (this.loggedInUserRole == 'HOD') {
            data = userlist.filter((elm: any) =>
              this.loggedInUserEmployeeCode === elm.hodCode ||
              elm.managerCode == this.loggedInUserEmployeeCode &&
              elm.userId != this.loggedInUserId
            );
          } else {
            data = userlist.filter((elm: any) =>

              elm.managerCode == this.loggedInUserEmployeeCode &&
              elm.userId != this.loggedInUserId
            );
          }
          this.listofFromData = data;
          this.currentlistofFromData = data

        }

        else if (

          this.checkAuthority == 'HOD_AND_MANAGER_AND_HR' &&
          !isAdminRole
        ) {
          console.log("inside HOD_AND_MANAGER_AND_HR");
          console.log(userlist);

          let data = userlist.filter((elm: any) => this.loggedInUserEmployeeCode == elm.managerCode && elm.userId != this.loggedInUserId);

          this.listofFromData = data;
          this.currentlistofFromData = data

        }

        else if (isAdminRole) {
          let data = userlist
          this.listofFromData = data;
          this.currentlistofFromData = data
        }

        else {

        }
        this.filterByFiscalMonthRange(this.fromDate)
      }, 800)
    })
  }


  onTabClick(tab: any) {
    if (tab.ModuleName === 'Resigned Emp' || tab.ModuleName == 'Regrettable Emp' || tab.ModuleName == 'Resignation Accepted Emp') {

      this.onClickOpenPopup(this.passData, tab); // You can pass userId if needed

    }


    if (tab.ModuleName == 'Terminated Emp') {

      console.log("jffffffffgk");

      this.onClickOpenPopup(this.passTerminationData, tab);
    }


  }

  onClickOpenPopup(tabData: any, tab: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '80%';
    dialogConfig.width = '80%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      userID: tabData,
      tab: tab

    };
    dialogConfig.panelClass = 'phi_mdc_dialog__container_100';
    const dialogRef = this.dialog.open(ElcmExitPopUpComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      // this.getProbationList();
    });
  }


  fiscalStartYear: any;
  fiscalEndYear: any;
  startMonth: any;
  endMonth: any;
  filteredResignations: any;
  regrateCount: any;
  passData: any;
  resignationAcceptedCount: any;
  terminatedCount: any;
  passTerminationData: any
  getFiscalMonth(fiscalType: string): number {
    const month = new Date().getMonth(); // Get the current month (0-based index)

    switch (fiscalType) {
      case 'Jan_Dec':
        return month + 1; // For Jan-Dec fiscal year, the month is as per the calendar year
      case 'Apr_Mar':
        return (month + 9) % 12 + 1;  // Adjust months for Apr-Mar fiscal year
      case 'July_Jun':
        return (month + 6) % 12 + 1;  // Adjust months for Jul-Jun fiscal year
      case 'Oct_Sep':
        return (month + 3) % 12 + 1;  // Adjust months for Oct-Sep fiscal year
      default:
        return month + 1;  // Default to Jan-Dec if no fiscal type matches
    }
  }
  filterByFiscalMonthRange(formDate: any) {
    const startMonth = this.getFiscalMonth(this.loggedInCompanyFiscalyear);
    let months: number[] = [];

    // Based on fiscal year start, calculate months in the fiscal range
    if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
      months = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];  // April to March months
    } else if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
      months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];  // January to December months
    } else if (this.loggedInCompanyFiscalyear === 'July_Jun') {
      months = [7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6];  // July to June months
    } else if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
      months = [10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9];  // October to September months
    }
    console.log(this.listofFromData);

    // Filtering the list based on 'createdAt' month being <= 5 and in the fiscal month range
    let filteredMonths = this.listofFromData?.filter((elm: any) => {
      const createdMonth = new Date(elm.createdAt).getMonth() + 1; // +1 to adjust 0-based month index
      // Check if created month is 5 or less, and if it falls within the fiscal months range
      return (createdMonth <= formDate) && months.includes(createdMonth);
    });

    // Filtering the list based on 'createdAt' month being <= 5 and in the fiscal month range
    let filteredMonthsDataForTermination = this.currentterminationEmployeeList.filter((elm: any) => {
      const createdMonth = new Date(elm.createdAt).getMonth() + 1; // +1 to adjust 0-based month index
      // Check if created month is 5 or less, and if it falls within the fiscal months range
      return (createdMonth <= formDate) && months.includes(createdMonth);
    });
    this.passData = filteredMonths?.filter((elm: any) => elm.userId != this.loggedInUserId);



    this.passTerminationData = filteredMonthsDataForTermination;
    this.regrateCount = filteredMonths?.filter((elm: any) => (elm.regretType == "Yes" && (elm.withdrawalReason == '' || elm.withdrawalReason == null)));
    this.filteredResignations = filteredMonths?.filter(
      (elm: any) =>
        (elm.withdrawalReason == '' || elm.withdrawalReason == null) &&
        elm.userId != this.loggedInUserId
    );

    console.log(this.filteredResignations);


    this.resignationAcceptedCount = filteredMonths?.filter((elm: any) =>
      elm.approvalStatus == "APPROVED" &&
      (elm.withdrawalReason == '' || elm.withdrawalReason == null)
    );

    this.terminatedCount = filteredMonthsDataForTermination.filter((elm: any) => elm.revolveStatus == false);


    this.manageeveryTabCount()
    console.log(filteredMonths);  // Log the filtered result
  }









}
interface TransformedDataItem {
  xAxisValueData: string;
  seriesValueOneData: number;
  seriesValueTwoData: number;
  seriesValueThreeData: number
}
interface TransformedData extends Array<TransformedDataItem> {
  xAxisName?: string;
  yAxisName?: string;
  seriesLabelOne?: string;
  seriesLabelTwo?: string;
  seriesLabelThree?: string
}
interface ChartDataItem {
  xAxisValueData: string;
  seriesValueOneData: any;
  seriesValueTwoData: any;
  seriesValueThreeData: any;
}

interface ChartDataArray extends Array<ChartDataItem> {
  xAxisName?: string;
  yAxisName?: string;
  seriesLabelOne?: string;
  seriesLabelTwo?: string;
  seriesLabelThree?: string;
}

